// Web push client. Rare, actionable taps: clinical alerts, overdue rounds, messages, fixed tickets.
// The prompt is asked ONCE (after login) and never again unless the user turns it on from the header.
import axios from 'axios';
const API = process.env.REACT_APP_API_URL || 'https://tcio-api.onrender.com';
export const pushSupported = () => typeof window !== 'undefined' && 'serviceWorker' in navigator && 'PushManager' in window && 'Notification' in window;
export const pushPermission = () => (pushSupported() ? Notification.permission : 'unsupported');
const b64ToU8 = (s) => { const p = '='.repeat((4 - s.length % 4) % 4); const b = (s + p).replace(/-/g, '+').replace(/_/g, '/'); const r = atob(b); return Uint8Array.from([...r].map(c => c.charCodeAt(0))); };

async function subscribe() {
  const reg = await navigator.serviceWorker.register('/sw.js', { scope: '/' });
  await navigator.serviceWorker.ready;
  const k = await axios.get(`${API}/api/push/public-key`);
  if (!k.data.enabled || !k.data.key) return { ok: false, reason: 'server_disabled' };
  let sub = await reg.pushManager.getSubscription();
  if (!sub) sub = await reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: b64ToU8(k.data.key) });
  await axios.post(`${API}/api/push/subscribe`, { subscription: sub.toJSON() });
  return { ok: true };
}
// Silent: only when permission is already granted (each login re-registers the device).
export async function ensurePushSubscription() {
  if (!pushSupported() || Notification.permission !== 'granted') return { ok: false, reason: Notification.permission };
  try { return await subscribe(); } catch (e) { return { ok: false, reason: e.message }; }
}
// Explicit: from the prompt or the header toggle.
export async function requestPush() {
  if (!pushSupported()) return { ok: false, reason: 'unsupported' };
  const p = await Notification.requestPermission();
  localStorage.setItem('tcio_push_asked', '1');
  if (p !== 'granted') return { ok: false, reason: p };
  try { return await subscribe(); } catch (e) { return { ok: false, reason: e.message }; }
}
export async function sendTestPush() { try { const r = await axios.post(`${API}/api/push/test`); return r.data; } catch (e) { return { ok: false }; } }
export const pushAsked = () => localStorage.getItem('tcio_push_asked') === '1';
export const markPushAsked = () => localStorage.setItem('tcio_push_asked', '1');
